import React, { useState, useEffect, useCallback } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import { Helmet } from 'react-helmet';
import { TAKEWIDGET_PROPERTY_ID, TAKEWIDGET_PAGE_ID } from './lib/config';
import './App.css'
import './css/button.css';
import './css/comman.css';
import './css/toggle.css';
import Home from './container/homes/home';
import Template from './container/tamplate/index.jsx';
import Application from './container/application';
import About from './container/staticPage/about';
import ContactUs from './container/staticPage/ContactUs';
import PrivacyPolicy from './container/staticPage/privacyPolicy';
// import ScrollToTop from './container/dem2';
import FullScreenView from './container/FullScreenView';
import Footer from './components/Footer/Footer';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import Refund from './pages/Refund';
import BlogPage from './container/blog/BlogPage';
import BlogPost from './container/blog/BlogPost';
import TawkWidget from './components/chat/TawkWidget';
import CookieConsent from './components/CookieConsent/CookieConsent';
import Header from './components/Header/Header';
import ShareModal from './components/ShareModal/ShareModal';
import ContentPolicyModal from './components/ContentPolicyModal/ContentPolicyModal';
import InstallPrompt from './components/InstallPrompt/InstallPrompt';
import AppSnackbar from './components/AppSnackbar/AppSnackbar';
import PaywallModal from './components/videoPaywall/PaywallModal';
import PaymentSuccessModal from './components/videoPaywall/PaymentSuccessModal';
import RecoverDownloadModal from './components/videoPaywall/RecoverDownloadModal';
import Login from './pages/Login';
import Signup from './pages/Signup';
import VerifyEmail from './pages/VerifyEmail';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Profile from './pages/Profile';
import { containsBlockedContent, getBlockedMatches } from './utils/contentModeration';
import { createCheckoutSession, unlockToken, recoverOrder, simulatePaidIfAvailable } from './utils/paymentApi';
import {
  getGuestAccessCode,
  setGuestAccessCode,
  getLastOrderId,
  setLastOrderId,
} from './utils/guestStorage';
import {
  saveEditorDraft,
  loadEditorDraft,
  resolveEditorText,
  clearEditorDraft,
} from './utils/editorDraft';
import {
  initLemonSqueezy,
  setupLemonCheckoutEvents,
  openLemonCheckout,
} from './utils/lemonCheckout';
import { trackPaywallFunnelEvent } from './utils/paywallAnalytics';
import { showError, showWarning, showInfo, showSuccess } from './utils/snackbar';
import _ from 'lodash';

// Inside Router: open success/cancel/recover modals from query string
function PaymentQueryHandler({ onPaymentSuccess, onPaymentCancelled, onRecover }) {
  const location = useLocation();

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const payment = urlParams.get('payment');
    const order = urlParams.get('order');
    const recover = urlParams.get('recover');
    if (payment === 'success') {
      onPaymentSuccess(order);
      window.history.replaceState({}, '', window.location.pathname);
    } else if (payment === 'cancelled') {
      onPaymentCancelled();
      window.history.replaceState({}, '', window.location.pathname);
    } else if (recover === '1' || recover === 'true') {
      onRecover();
      window.history.replaceState({}, '', window.location.pathname);
    }
  }, [location.search, onPaymentSuccess, onPaymentCancelled, onRecover]);

  return null;
}

function App() {
  const [color, setColor] = useState('#FFFF00');
  const [name, setName] = useState('');
  const [speed, setSpeed] = useState(30);
  const [isFlipText, setIsFlipText] = useState(false);
  const [blinkSpeend, setBlinkSpeend] = useState(30);
  const [fontSize, setfontSize] = useState(85);
  const [isblink, setIsblink] = useState(true);
  const [bgColor, setbgColor] = useState('#000000');
  const [RGB, setRGB] = useState({
    r: 92,
    g: 102,
    b: 122
  });
  const [isGeneratingVideo, setIsGeneratingVideo] = useState(false);
  const [videoProgress, setVideoProgress] = useState(0);
  const [pendingVideoGeneration, setPendingVideoGeneration] = useState(false);
  const [showShareModal, setShowShareModal] = useState(false);
  const [showContentPolicyModal, setShowContentPolicyModal] = useState(false);
  const [contentPolicyMatches, setContentPolicyMatches] = useState([]);
  const [showPaywall, setShowPaywall] = useState(false);
  const [paywallLoading, setPaywallLoading] = useState(false);
  const [paywallError, setPaywallError] = useState('');
  const [showPaymentSuccess, setShowPaymentSuccess] = useState(false);
  const [paidOrderId, setPaidOrderId] = useState('');
  const [paidAccessCode, setPaidAccessCode] = useState('');
  const [downloadError, setDownloadError] = useState('');
  const [showRecover, setShowRecover] = useState(false);
  const [recoverLoading, setRecoverLoading] = useState(false);
  const [recoverError, setRecoverError] = useState('');

  // Load text from URL query, else restore paywall draft after Lemon remount
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const textParam = urlParams.get('text');
    if (textParam) {
      const decodedText = decodeURIComponent(textParam);
      setName(decodedText);
      return;
    }
    const draft = loadEditorDraft();
    const draftName = _.get(draft, 'name', '');
    if (!draftName) {
      return;
    }
    setName(draftName);
    setColor(_.get(draft, 'color', '#FFFF00'));
    setbgColor(_.get(draft, 'bgColor', '#000000'));
    setSpeed(_.get(draft, 'speed', 30));
    setfontSize(_.get(draft, 'fontSize', 85));
    setIsblink(!!_.get(draft, 'isblink', true));
    setBlinkSpeend(_.get(draft, 'blinkSpeed', 30));
    setIsFlipText(!!_.get(draft, 'isFlipText', false));
  }, []);

  // Snapshot editor fields for pay → download (session only)
  const snapshotEditorDraft = useCallback(() => {
    saveEditorDraft({
      name,
      color,
      bgColor,
      speed,
      fontSize,
      isblink,
      blinkSpeed: blinkSpeend,
      isFlipText,
    });
  }, [name, color, bgColor, speed, fontSize, isblink, blinkSpeend, isFlipText]);

  // Apply draft into React state when live name was lost (redirect remount)
  const hydrateEditorFromDraft = useCallback(() => {
    if (String(name || '').trim()) {
      return true;
    }
    const draft = loadEditorDraft();
    const draftName = _.get(draft, 'name', '');
    if (!draftName) {
      return false;
    }
    setName(draftName);
    setColor(_.get(draft, 'color', '#FFFF00'));
    setbgColor(_.get(draft, 'bgColor', '#000000'));
    setSpeed(_.get(draft, 'speed', 30));
    setfontSize(_.get(draft, 'fontSize', 85));
    setIsblink(!!_.get(draft, 'isblink', true));
    setBlinkSpeend(_.get(draft, 'blinkSpeed', 30));
    setIsFlipText(!!_.get(draft, 'isFlipText', false));
    return true;
  }, [name]);

  // Lemon return / Footer recover query → modals
  // Local: also call simulate-paid when BE ENABLE_DEV_PAYMENT_SIM is on (webhook cannot hit localhost)
  const handlePaymentSuccessQuery = useCallback(async (order) => {
    // Restore LED text if React state was cleared by redirect remount (do not overwrite live text)
    const draft = loadEditorDraft();
    const draftName = _.get(draft, 'name', '');
    if (draftName) {
      setName((prev) => {
        if (String(prev || '').trim()) {
          return prev;
        }
        setColor(_.get(draft, 'color', '#FFFF00'));
        setbgColor(_.get(draft, 'bgColor', '#000000'));
        setSpeed(_.get(draft, 'speed', 30));
        setfontSize(_.get(draft, 'fontSize', 85));
        setIsblink(!!_.get(draft, 'isblink', true));
        setBlinkSpeend(_.get(draft, 'blinkSpeed', 30));
        setIsFlipText(!!_.get(draft, 'isFlipText', false));
        return draftName;
      });
    }
    const access = getGuestAccessCode();
    const resolvedOrder = order || getLastOrderId();
    setPaidOrderId(resolvedOrder);
    setPaidAccessCode(access);
    setShowPaywall(false);
    setPaywallLoading(false);
    if (resolvedOrder) {
      setLastOrderId(resolvedOrder);
      await simulatePaidIfAvailable(resolvedOrder);
    }
    // Funnel: payment confirmed (no order id / PII in GA)
    trackPaywallFunnelEvent('payment_success', {
      event_label: 'Lemon payment success',
      value: 1,
    });
    setShowPaymentSuccess(true);
  }, []);

  const handlePaymentCancelledQuery = useCallback(() => {
    trackPaywallFunnelEvent('checkout_cancel', {
      event_label: 'lemon_checkout_cancelled',
      value: 1,
    });
    showInfo('Checkout cancelled. You can try again anytime.');
  }, []);

  const handleRecoverQuery = useCallback(() => {
    setShowRecover(true);
  }, []);

  // Lemon.js overlay: init + Checkout.Success → same success modal as redirect
  useEffect(() => {
    initLemonSqueezy();
    setupLemonCheckoutEvents((event) => {
      const eventName = _.get(event, 'event', '');
      if (eventName === 'Checkout.Success') {
        const lastOrder = getLastOrderId();
        handlePaymentSuccessQuery(lastOrder);
      }
    });
  }, [handlePaymentSuccessQuery]);

  const callVibrate = () => {
    navigator.vibrate = navigator.vibrate || navigator.webkitVibrate || navigator.mozVibrate || navigator.msVibrate;
    if (navigator.vibrate) {
      navigator.vibrate(20);
    }
  }

  const handlBgcolor = (color) => {
    setbgColor(color);
    const r = parseInt(color.substr(1, 2), 16)
    const g = parseInt(color.substr(3, 2), 16)
    const b = parseInt(color.substr(5, 2), 16)
    setRGB({
      r: r,
      g: g,
      b: b
    });
  }

  const handleSpeedChanger = (val) => {
    setSpeed(val);
  };

  const handleBlinkSpeedChanger = (val) => {
    setBlinkSpeend(val);
  };

  const pluseFonthandler = () => {
    if (isMobile) {
      if (fontSize < 100) {
        setfontSize(fontSize + 1);
      }
      callVibrate();
    } else {
      if (fontSize < 100) {
        setfontSize(fontSize + 1);
      }
      callVibrate();
    }
  }

  const minusFonthandler = () => {
    if (isMobile) {
      if (fontSize > 12) {
        setfontSize(fontSize - 1);
      }
      callVibrate();
    } else {
      if (fontSize > 30) {
        setfontSize(fontSize - 1);
      }
      callVibrate();
    }
  }

  const handleBlinkToggle = (e) => {
    setIsblink(!isblink);
  }

  const onCycleComplete = (data) => {
    // Handle cycle completion
  }

  const handleNavigationClick = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const handleShareUrl = () => {
    // Track Share button click
    if (window.gtag && window.cookieConsentGiven) {
      window.gtag('event', 'share_button_click', {
        event_category: 'User Engagement',
        event_label: 'Share Button Clicked',
        value: 1
      });
    }

    // Open share modal instead of native share
    setShowShareModal(true);
    callVibrate();
  };

  // Local EN/HI content policy gate for Download / Full Screen only
  // source: 'download' | 'fullscreen' — used for GA count only (no word/text tracking)
  const assertContentAllowed = (source = 'unknown') => {
    if (containsBlockedContent(name)) {
      setContentPolicyMatches(getBlockedMatches(name));
      setShowContentPolicyModal(true);

      // Aggregate block count only — never send blocked words or LED text
      if (window.gtag && window.cookieConsentGiven) {
        window.gtag('event', 'content_policy_blocked', {
          event_category: 'Content Policy',
          event_label: source,
          value: 1
        });
      }
      return false;
    }
    return true;
  };

  const handleSaveAsVideo = async () => {
    // Check if text is empty
    if (!name || name.trim().length === 0) {
      showWarning('Please enter some text first.');
      return;
    }

    // Block NSFW / prohibited language before ad or video generation
    if (!assertContentAllowed('download')) {
      return;
    }

    const textLength = name.length;
    
    // Track Download Video button click
    if (window.gtag && window.cookieConsentGiven) {
      window.gtag('event', 'download_video_click', {
        event_category: 'Video Generation',
        event_label: 'Download Video Button Clicked',
        text_length: textLength,
        value: 1
      });
    }

    // Check for long text and show warning
    if (textLength > 120) {
      const confirmProceed = window.confirm(
        `Your text is ${textLength} characters long. Generating video for long text may take longer to process and use more memory. Do you want to continue?`
      );
      if (!confirmProceed) {
        if (window.gtag && window.cookieConsentGiven) {
          window.gtag('event', 'video_generation_cancelled', {
            event_category: 'Video Generation',
            event_label: 'User Cancelled Long Text Video',
            text_length: textLength,
            value: 1
          });
        }
        return;
      }
    }

    // Open paid video paywall (FullScreenAd no longer gates download)
    snapshotEditorDraft();
    setPendingVideoGeneration(true);
    setPaywallError('');
    setShowPaywall(true);
    // Funnel: paywall shown (purchase UI — not an ad)
    trackPaywallFunnelEvent('paywall_view', {
      event_label: 'Video export paywall opened',
      value: 1,
    });
  };

  // Start Lemon checkout session (overlay first; redirect if Lemon.js unavailable)
  const handlePaywallPay = async () => {
    try {
      // Fresh snapshot right before Lemon (covers overlay + redirect remount)
      snapshotEditorDraft();
      setPaywallLoading(true);
      setPaywallError('');
      const guestAccessCode = getGuestAccessCode();
      const result = await createCheckoutSession(guestAccessCode || undefined);
      const checkoutUrl = _.get(result, 'checkoutUrl', '');
      const orderId = _.get(result, 'orderId', '');
      const accessCode = _.get(result, 'guestAccessCode', '');
      if (accessCode) {
        setGuestAccessCode(accessCode);
      }
      if (orderId) {
        setLastOrderId(orderId);
      }
      if (!checkoutUrl) {
        const msg = 'Unable to open checkout. Please try again.';
        setPaywallError(msg);
        showError(msg);
        return;
      }
      // Funnel: Lemon checkout opened (no order id in GA)
      trackPaywallFunnelEvent('checkout_start', {
        event_label: 'Lemon checkout opened',
        value: 1,
      });
      // Hide our paywall so Lemon overlay is visible on the same page
      setShowPaywall(false);
      openLemonCheckout(checkoutUrl);
    } catch (e) {
      const msg = _.get(e, 'message', 'Checkout failed. Please try again.');
      setPaywallError(msg);
      showError(msg);
      setShowPaywall(true);
    } finally {
      setPaywallLoading(false);
    }
  };

  // User closed paywall without starting checkout (not recover, not Lemon open)
  const handlePaywallClose = () => {
    trackPaywallFunnelEvent('checkout_cancel', {
      event_label: 'paywall_dismissed',
      value: 1,
    });
    setShowPaywall(false);
    setPendingVideoGeneration(false);
  };

  // After paid success modal — unlock, generate in-modal, then close when download starts
  const handlePaidDownload = async () => {
    try {
      setDownloadError('');
      // Resolve text before unlock so we never burn a download on empty placeholder
      const textForVideo = resolveEditorText(name);
      if (!textForVideo) {
        const msg =
          'Enter your LED text on the Home page first, then click Download video now again.';
        setDownloadError(msg);
        showWarning(msg);
        return;
      }
      hydrateEditorFromDraft();
      setIsGeneratingVideo(true);
      setVideoProgress(0);
      const orderId = paidOrderId || getLastOrderId();
      const guestAccessCode = paidAccessCode || getGuestAccessCode();
      await unlockToken({ orderId, guestAccessCode });
      const ok = await generateVideo(textForVideo);
      if (ok) {
        clearEditorDraft();
        setPendingVideoGeneration(false);
        setShowPaymentSuccess(false);
        showSuccess('Download started');
      }
    } catch (e) {
      const msg = _.get(e, 'message', 'Unable to unlock download.');
      setDownloadError(msg);
      showError(msg);
      setIsGeneratingVideo(false);
      setVideoProgress(0);
    }
  };

  // Recover paid order then download
  const handleRecoverSubmit = async ({ orderId, guestAccessCode }) => {
    try {
      setRecoverLoading(true);
      setRecoverError('');
      await recoverOrder({ orderId, guestAccessCode });
      setGuestAccessCode(guestAccessCode);
      setLastOrderId(orderId);
      setPaidOrderId(orderId);
      setPaidAccessCode(guestAccessCode);
      setShowRecover(false);
      setShowPaymentSuccess(true);
    } catch (e) {
      const msg = _.get(e, 'message', 'Recover failed.');
      setRecoverError(msg);
      showError(msg);
    } finally {
      setRecoverLoading(false);
    }
  };

  // Legacy ad-close path removed — unpaid download must not call generateVideo

  // Extract video generation (optional textOverride for pay→download after remount)
  const generateVideo = async (textOverride) => {
    try {
      setIsGeneratingVideo(true);
      setVideoProgress(0);

      const draft = loadEditorDraft();
      const textForVideo = String(
        textOverride != null && String(textOverride).trim()
          ? textOverride
          : name || _.get(draft, 'name', '') || ''
      ).trim();
      if (!textForVideo) {
        showError('Please enter some text first.');
        setIsGeneratingVideo(false);
        return false;
      }

      // Prefer live editor settings; use draft only when remount wiped state
      const liveMissing = !String(name || '').trim();
      const colorForVideo = liveMissing ? _.get(draft, 'color', color) : color;
      const bgForVideo = liveMissing ? _.get(draft, 'bgColor', bgColor) : bgColor;
      const speedForVideo = liveMissing ? _.get(draft, 'speed', speed) : speed;
      const fontForVideo = liveMissing ? _.get(draft, 'fontSize', fontSize) : fontSize;
      const blinkForVideo = liveMissing ? !!_.get(draft, 'isblink', isblink) : isblink;
      const blinkSpeedForVideo = liveMissing
        ? _.get(draft, 'blinkSpeed', blinkSpeend)
        : blinkSpeend;
      const flipForVideo = liveMissing ? !!_.get(draft, 'isFlipText', isFlipText) : isFlipText;
      
      // Import the video generator functions
      const { generateMarqueeVideo, downloadBlob } = await import('./utils/videoGenerator');
      
      // Find the marquee container element
      const marqueeElement = document.querySelector('.outerBox');
      
      if (!marqueeElement) {
        showError('Marquee element not found. Please ensure the text is displayed.');
        setIsGeneratingVideo(false);
        return false;
      }

      // Check MediaRecorder support
      if (!window.MediaRecorder) {
        showError(
          'Video recording is not supported in your browser. Please use a modern browser like Chrome, Firefox, or Edge.'
        );
        setIsGeneratingVideo(false);
        return false;
      }

      // Generate the video
      const videoBlob = await generateMarqueeVideo(
        marqueeElement,
        {
          text: textForVideo,
          color: colorForVideo,
          bgColor: bgForVideo,
          speed: speedForVideo,
          fontSize: fontForVideo,
          isblink: blinkForVideo,
          blinkSpeed: blinkSpeedForVideo,
          isFlipText: flipForVideo,
          direction: 'left'
        },
        (progress) => {
          setVideoProgress(progress);
        }
      );

      // Determine file extension based on blob type
      const mimeType = videoBlob.type;
      const extension = mimeType.includes('mp4') ? 'mp4' : 'webm';
      
      // Download the video
      const filename = `led-scroller-${textForVideo.replace(/\s+/g, '-').toLowerCase() || 'animation'}-${Date.now()}.${extension}`;
      downloadBlob(videoBlob, filename);
      
      // Track successful video download only if consent is given
      if (window.gtag && window.cookieConsentGiven) {
        window.gtag('event', 'video_download_success', {
          event_category: 'Video Generation',
          event_label: 'Video Successfully Downloaded',
          text_length: textForVideo.length,
          video_format: extension,
          value: 1
        });
      }
      
      setIsGeneratingVideo(false);
      setVideoProgress(0);
      callVibrate();
      return true;
    } catch (error) {
      console.error('Error generating video:', error);
      
      // Track error with Google Analytics only if consent is given
      if (window.gtag && window.cookieConsentGiven) {
        window.gtag('event', 'video_generation_error', {
          event_category: 'Video Generation',
          event_label: error.message || 'Unknown error',
          value: 1
        });
      }
      
      showError('Failed to generate video. Please try again. Error: ' + error.message);
      setIsGeneratingVideo(false);
      setVideoProgress(0);
      return false;
    }
  };

  return (
    <Router>
      <PaymentQueryHandler
        onPaymentSuccess={handlePaymentSuccessQuery}
        onPaymentCancelled={handlePaymentCancelledQuery}
        onRecover={handleRecoverQuery}
      />
      <div className="App">
        <Helmet>
          <title>LED Scroller - LED Banner | Scrolling Text Generator | Digital Signage Online</title>
          <meta name="description" content="Create free scrolling LED banners and digital signage online. LED Scroller, LED Banner, programmable LED sign, scrolling text generator, digital display board, outdoor and indoor LED signs for business, events, and advertising." />
          <meta name="keywords" content="LED Scroller, LED Banner, scrolling text, digital signage, programmable LED sign, LED display board, scrolling LED sign, digital menu board, outdoor LED sign, indoor LED sign, custom LED sign, free LED text generator, LED message board, digital advertising, electronic sign, running text, LED sign software, cloud-based digital signage, digital display, LED sign for business, LED sign for events, LED sign for shop, multilingual LED sign" />
          <link rel="alternate" href="https://ledscroller.com/" hreflang="en" />
        </Helmet>
        <Routes>
          <Route path="/fullscreen-view" element={
            <FullScreenView
              fontSize={fontSize}
              name={name}
              isMobile={isMobile}
              speed={speed}
              RGB={RGB}
              isblink={isblink}
              blinkSpeend={blinkSpeend}
              isFlipText={isFlipText}
              bgColor={bgColor}
              setName={setName}
              color={color}
              finalResult={{
                name,
                color,
                bgColor,
                speed,
                r: RGB.r,
                g: RGB.g,
                b: RGB.b
              }}
            />
          } />
          <Route path="/*" element={
            <>
              <Header onNavigationClick={handleNavigationClick} />
              
              <Routes>
                <Route path="/" element={
                  <Home
                    onCycleComplete={onCycleComplete}
                    RGB={RGB}
                    isblink={isblink}
                    speed={speed}
                    setIsFlipText={setIsFlipText}
                    isFlipText={isFlipText}
                    name={name}
                    setName={setName}
                    handleBlinkToggle={handleBlinkToggle}
                    minusFonthandler={minusFonthandler}
                    fontSize={fontSize}
                    pluseFonthandler={pluseFonthandler}
                    color={color}
                    blinkSpeend={blinkSpeend}
                    setColor={setColor}
                    bgColor={bgColor}
                    handlBgcolor={handlBgcolor}
                    handleShareUrl={handleShareUrl}
                    handleSpeedChanger={handleSpeedChanger}
                    handleBlinkSpeedChanger={handleBlinkSpeedChanger}
                    handleSaveAsVideo={handleSaveAsVideo}
                    assertContentAllowed={assertContentAllowed}
                    isGeneratingVideo={isGeneratingVideo}
                    videoProgress={videoProgress}
                    progressOwnedByModal={showPaymentSuccess}
                  />
                } />
                <Route path="/template" element={<Template />} />
                <Route path="/application" element={<Application />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<ContactUs />} />
                <Route path="/privacy" element={<PrivacyPolicy />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/privacy-policy" element={<Privacy />} />
                <Route path="/refund-policy" element={<Refund />} />
                <Route path="/login" element={<Login />} />
                <Route path="/signup" element={<Signup />} />
                <Route path="/verify-email" element={<VerifyEmail />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/blog" element={<BlogPage />} />
                <Route path="/blog/:id" element={<BlogPost />} />
                <Route path="/fullscreen" element={<FullScreenView />} />
              </Routes>
              <Footer />
            </>
          } />
        </Routes>
      </div>
      <div className='tawk-widget-container'>
        <TawkWidget propertyId={TAKEWIDGET_PROPERTY_ID} pageId={TAKEWIDGET_PAGE_ID} />
      </div>
      <CookieConsent />
      <AppSnackbar />
      <PaywallModal
        isOpen={showPaywall}
        onClose={handlePaywallClose}
        onPay={handlePaywallPay}
        onRecover={() => {
          setShowPaywall(false);
          setShowRecover(true);
        }}
        loading={paywallLoading}
        error={paywallError}
        priceLabel="USD $1.49"
      />
      <PaymentSuccessModal
        isOpen={showPaymentSuccess}
        orderId={paidOrderId || getLastOrderId()}
        guestAccessCode={paidAccessCode || getGuestAccessCode()}
        onDownload={handlePaidDownload}
        onClose={() => {
          if (!isGeneratingVideo) {
            setShowPaymentSuccess(false);
          }
        }}
        downloading={isGeneratingVideo}
        downloadProgress={videoProgress}
        error={downloadError}
      />
      <RecoverDownloadModal
        isOpen={showRecover}
        onClose={() => setShowRecover(false)}
        onRecover={handleRecoverSubmit}
        loading={recoverLoading}
        error={recoverError}
        initialOrderId={getLastOrderId()}
        initialAccessCode={getGuestAccessCode()}
      />
      {/* Share Modal */}
      <ShareModal
        isOpen={showShareModal}
        onClose={() => setShowShareModal(false)}
        shareText={name}
      />
      {/* Content policy warning — NSFW / prohibited LED text */}
      <ContentPolicyModal
        isOpen={showContentPolicyModal}
        onClose={() => {
          setShowContentPolicyModal(false);
          setContentPolicyMatches([]);
        }}
        matches={contentPolicyMatches}
      />
      {/* PWA Install Prompt - Only shows on mobile/tablet */}
      {/* <InstallPrompt /> */}
    </Router>
  );
}

export default App;
